// extracted by mini-css-extract-plugin
export default {"form":"Search_form__cKMH6","search":"Search_search__iII9B","button":"Search_button__RYOeC","svg":"Search_svg__J5Cdg"};